import Typography from "@common/components/Typography";
import { Paper } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from "react";
import { useTranslation } from "react-i18next";
import { AddParticipantContext } from "..";
import RoomCard from "../RoomCard";

type SelectedRoomsProps = {};

const SelectedRooms = (props: SelectedRoomsProps) => {
  const {} = props;
  const { selectedRooms, isCustomRoom } = React.useContext(
    AddParticipantContext
  );
  const { t } = useTranslation();

  return (
    <Grid
      container
      direction="column"
      wrap="nowrap"
      sx={{ width: '100%', height: "100%",
        gap: "1rem", }}
    >
      <Typography size="medium">{t("Selected Rooms")}</Typography>
      <Paper
        sx={{
          height: "100%",
          padding: 1,
          overflow: "auto",
        }}
      >
        <Grid
          container
          direction="column"
          sx={{ width: '100%', gap: "1rem", }}
        >
          {selectedRooms.map((room) =>
            isCustomRoom(room) ? (
              <RoomCard key={room.id} customRoom={room} />
            ) : (
              <RoomCard key={room.id} room={room} />
            )
          )}
        </Grid>
      </Paper>
    </Grid>
  );
};

export default SelectedRooms;
